import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export const RutFillTypes = {
  DotsAndDash: 'DotsAndDash',
  OnlyNumbers: 'OnlyNumbers',
  OnlyDash: 'OnlyDash'
}

export class RutInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value, type, rutType }) {
    super({
      name: 'Rut',
      label,
      waitForNoLoaders,
      value,
      type

    })
    this.rutType = rutType
  }

  setDefaultValue (params) {
    this.value = this.parseRutBasedOnType(params.userInformation.rut)
  }

  parseRutBasedOnType = (rut) => {
    switch (this.rutType) {
      case RutFillTypes.DotsAndDash:
        return rut
      case RutFillTypes.OnlyNumbers:
        return rut.replace(/[^0-9]/g, '')
      case RutFillTypes.OnlyDash:
        return rut.replace(/[^-]/g, '')
      default:
        return rut
    }
  }
}
